import Handlebars from "@cirrus/legacy/vendor-bower/handlebars/handlebars"

Handlebars.registerHelper("skinStyle", function (value) {
  var style = App.skinStyles && App.skinStyles[value]
  return style || ""
})
